// ----------------- START PURCHASE SCRIPT ------------------------------------

// `breeze-purchase` event listener
window.addEventListener("breeze-purchase", (event) => {
  const eventData = event.detail;
  breezePurchase(eventData);
});

// This function will be invoked by breeze after purchase
function breezePurchase(payload) {
  try {
    merchantPurchaseCustomCode(payload.data);
  } catch (e) {
    console.log("Error in triggering merchants purchase script : ", e);
  }
}

// merchant script for `purchase` will be pasted here
function merchantPurchaseCustomCode(params) {

  // GOOGLE ADS PURCHASE EVENT CODE START
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    dataLayer.push(arguments);
  }
  gtag("js", new Date());
  gtag("config", "AW-11424021235");
  window.gtag("event", "conversion", {
    send_to: ["AW-11424021235/n7SCCJTd0pkaEPP1sscq"],
    value: params.totalPrice,
    currency: "INR",
    transaction_id: params.shopOrderId,
    triggered_by: "breeze"
  });
  // GOOGLE ADS PURCHASE EVENT CODE END
  
}

// ----------------- END PURCHASE SCRIPT --------------------------------------

// ----------------- START ADD_PAYMENT_INFO SCRIPT ----------------------------

// `breeze-add-payment-info` event listener
window.addEventListener("breeze-add-payment-info", (event) => {
  const eventData = event.detail;
  breezeAddPaymentInfo(eventData);
});

// This function will be invoked by breeze after add payment info
function breezeAddPaymentInfo(payload) {
  try {
    merchantAddPaymentInfoCustomCode(payload.data);
  } catch (e) {
    console.log("Error in triggering merchants add Payment info script : ", e);
  }
}

// merchant script for `add_payment_info` will be pasted here
function merchantAddPaymentInfoCustomCode(params) {

    // paste the snippet out here
    gtag("event", "page_view", {
        send_to: ["G-SW09KDK5QQ", "MC-VEY0D19TDQ"],
        page_path: params.currentLocation,
        page_title: "Checkout - Processing",
        page_location: params.currentLocation,
        ignore_referrer: true
    });
    // Sending History Change Event to Google Ads
    gtag("event", "page_view", {
        page_location: params.currentLocation,
        page_referrer: params.currentLocation,
        send_to: "AW-11424021235"
    });
    // Sending History Change Event to Merchant Center
    gtag("event", "page_view", {
        page_location: params.currentLocation,
        page_referrer: params.currentLocation,
        send_to: "MC-VEY0D19TDQ"
    });
    // Sending History Change Event to Google Analytics
    gtag("event", "page_view", {
        page_location: params.currentLocation,
        page_referrer: params.currentLocation,
        send_to: "G-SW09KDK5QQ"
    });
  
}

// ----------------- END ADD_PAYMENT_INFO SCRIPT ------------------------------

// ----------------- START BEGIN_CHECKOUT SCRIPT ------------------------------

// `breeze-initiate-checkout` event listener
window.addEventListener("breeze-initiate-checkout", (event) => {
  const eventData = event.detail;
  breezeInitiateCheckout(eventData);
});

// This function will be invoked by breeze after begin checkout
function breezeInitiateCheckout(payload) {
  try {
    merchantInitiateCheckoutCustomCode(payload.data);
  } catch (e) {
    console.log("Error in triggering merchants initiate checkout script : ", e);
  }
}

// merchant script for `begin_checkout` will be pasted here
function merchantInitiateCheckoutCustomCode(params) {
   window.gtag("event", "begin_checkout", {
      send_to: ["AW-11424021235/Bl5GCMzIpJQZEPP1sscq"],
      value: params.totalPrice,
      currency: params.currency,
      breeze_event_type: "breeze_checkout_initiated",
      triggered_by: "breeze"
    })

  
}

// ----------------- END BEGIN_CHECKOUT SCRIPT --------------------------------
